import React, { useEffect, useRef, useState } from 'react';
import { mainPath } from '../../Structure/Constants/MainPath';

const CustomImageUpload = (props:{onSelect:(img:File|null)=>void , clear?:(action:()=>void)=>void }) => {
  const initial:string = `${mainPath}/assets/images/empty.png`
  const [selectedImage, setSelectedImage] = useState<File|null>(null);

  useEffect(()=>{if(props.clear)props.clear(()=>setSelectedImage(null))},[])
  useEffect(()=>{ props.onSelect(selectedImage) },[selectedImage])
    const inp = useRef<HTMLInputElement>(null)
    const inpClicked = ()=>{
        inp.current?.click()
    }
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }else setSelectedImage(null);
  };

  return (
    <div className="input-file d-flex justify-content-around w-100 h-100 my-auto position-relative" onClick={()=>inpClicked()}>
      <input
        ref={inp}
        type="file"
        id="upload-button"
        accept="image/*,application/pdf"
        style={{ display: 'none' }}
        onChange={handleImageChange}
      />
      {
        selectedImage?(
          selectedImage.type === "application/pdf"?(
            <div  style={{ height:'50px' }} >
              <div className='d-flex flex-column h-100 justify-content-center'>
                <h6>{selectedImage.name}</h6>
              </div>
            </div>
          ):(
            <div className='' >
              <img
                height={70}
                src={URL.createObjectURL(selectedImage)}
                alt="Preview"
                style={{ objectFit:'cover'}} 
              />
            </div>
          )
        ):(
          <div className='' >
            <img
              height={70}
              src={initial}
              alt="Preview"
              style={{ objectFit:'cover'}} 
            />
          </div>
        )
      }
              <div 
            className='position-absolute material-symbols-outlined text-danger' 
            style={{ 
                top:'10px',
                left:'10px',
                zIndex:'10px'
             }}
            onClick={()=>setSelectedImage(null)}
             >
                close
        </div>
    </div>
  );
};

export default CustomImageUpload;
